module.exports = __webpack_public_path__ + "dd8b6ffebd5b85c6f5638ef5d97db06b.pdf";